import * as React from "react";
import { FieldCheckbox } from "./FieldCheckbox";
import clx from 'classnames'

type Props = {
    associated?: boolean
    checked?: boolean,
    children?: React.ReactNode
    className?: string
    hide?: boolean
    id?: string,
    indeterminate?: boolean,
    label?: string
    name?: string,
    readOnly?: boolean,
    value?: boolean,
    setValue?: (value: boolean) => void,
}

export const RowCheckbox = ({ 
    associated, className, hide, children, label, indeterminate, id, name, checked, value, setValue, readOnly
 }: Props) => {
    return hide ? null : (
        <div className={clx({
            'tw-py-2 tw-px-4': !associated,
            'tw-pl-8 tw-py-2 tw-pr-4': associated,
        }, className)}>
            <FieldCheckbox 
                indeterminate={indeterminate}
                checked={checked}
                id={id}
                label={label}
                disabled={readOnly}
                onChange={(e) => setValue(e.target.checked)}
            />
            {children}
        </div>
    )
}
